import React, { useEffect } from 'react';

export default function Toast({ message, type, onClose }) {
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(onClose, 2500);
    return () => clearTimeout(t);
  }, [message, onClose]);

  if (!message) return null;
  const bg = type === 'success' ? 'var(--g)' : 'var(--r)';
  return (
    <div style={{
      position: 'fixed', bottom: 80, left: '50%', transform: 'translateX(-50%)', zIndex: 300,
      background: bg, color: '#fff', padding: '12px 24px', borderRadius: 10,
      fontSize: 14, fontWeight: 600, boxShadow: '0 8px 24px rgba(0,0,0,.15)',
      animation: 'toastIn .25s ease', whiteSpace: 'nowrap', maxWidth: '90vw',
    }}>
      {type === 'success' ? '✓ ' : '✕ '}{message}
    </div>
  );
}
